
import { defineComponent, onMounted, ref } from 'vue';
import { IQuiz } from '@/types/quiz';
import { routeContractorsItem } from '@/core/constants';
import { useRoute, useRouter } from 'vue-router';
import QuestionAnswer from '@/components/Question/QuestionAnswer/QuestionAnswer.vue';
import { IQuestion } from '@/types/question';

export default defineComponent({
  name: 'ContractorCompanyUserItem',
  components: {
    QuestionAnswer
  },
  setup() {
    const documents = ref<IQuiz[]>([]);
    const router = useRouter();
    const route = useRoute();
    const {
      params: { id, userId }
    } = route;

    type IQuestionWithNullableCategory =
      Omit<IQuestion, "category_id"> & {
      category_id: null;
    }
    const questions = ref<IQuestionWithNullableCategory[]>([]);

    onMounted(() => {
      const payload = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      questions.value = payload.map(id => ({
        'id': id,
        'text': `Question ${id}`,
        'question_id': null,
        'category_id': null,
        'quiz_id': '578',
        'position': 2,
        'is_required': false,
        // 'is_visible': true,
        'attributes': null,
        'type': 'text',
        'answer_values': { },
        'rules': [],
        'user_answer': '',
        'created_at': new Date(),
        'updated_at': new Date(),
      }));
    });


    const businessFunctionId = ref(-1);

    const goToQuizEdit = (quizId: number) => { //@todo should be refactored
      router.push({
        name: routeContractorsItem,
        params: {
          id: quizId
        }
      });
    };


    const getQuestionIndexById = (questionId: number): number => {
      let questionIndex = -1;
      questions.value.forEach((question, ix) => {
        if (question.id === questionId) {
          questionIndex = ix;
        }
      });
      return questionIndex;
    };

    const handleValueUpdate = (questionId: number, val: string) => {
      const questionIX = getQuestionIndexById(questionId);
      questions.value[questionIX].user_answer = val;
      // saveResponseWithDebounce();
    };

    return {
      id,
      userId,
      documents,
      goToQuizEdit,
      businessFunctionId,
      questions,
      handleValueUpdate,
    };
  }
});
